import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { UseAvailabilityOptions, Slot } from '../types';
import { useNotificationStore } from '@/stores/notifications';

export const getAvailabilities = ({
  businessId,
  serviceId,
  duration,
  date,
  tz,
  userId,
  roomId,
  forRecurring,
}: UseAvailabilityOptions = {}): Promise<Slot[]> => {
  const reqParam: UseAvailabilityOptions = { duration, date, forRecurring };
  if (userId) {
    reqParam.userId = userId;
  }
  if (serviceId) {
    reqParam.serviceId = serviceId;
  }
  if (tz) {
    reqParam.tz = tz;
  }
  if (roomId) {
    return axios.get(`/rooms/${roomId}/daycare/availability`, {
      params: reqParam,
    });
  } else {
    return axios.get(`/business/calendar/availability`, {
      params: reqParam,
    });
  }
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getAvailabilities>;
};

export const useGetAvailabilities = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    ...config,
    mutationFn: getAvailabilities,
  });
};
